module.exports = __webpack_public_path__ + "static/media/grb.61ed6d10.png";